import numeral from 'numeral'
import { PrivateCourseType, PrivateRoomType } from '../types'

export const displayPrice = (num: number) => (num != null ? numeral(num).format('0,0') : 'N/A')
export const displayPrice2Digit = (num: number) => (num != null ? numeral(num).format('0,0.00') : 'N/A')
export const cloneObject = (data: object) => JSON.parse(JSON.stringify(data))

export const htmlDecode = (input: string): string => {
  const _input = input.replace(/&#8217;/gm, "'")
  var e = document.createElement('textarea');
  e.innerHTML = _input;
  // handle case of empty input
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue ? e.childNodes[0].nodeValue: '';
}

export const isPrivateCourseByName = (name: string, listPrivateCourse: PrivateCourseType[]): boolean => {
  return listPrivateCourse.some(privateCourse => privateCourse.name.toLowerCase() === name.toLowerCase())
}

export const isPrivateRoomByName = (name: string, listPrivateRoom: PrivateRoomType[]): boolean => {
  return listPrivateRoom.some(privateRoom => privateRoom.name.toLowerCase() === name.toLowerCase())
}